import type { StepType } from "@reactour/tour";
import TourStepContent from "./wrapper";
import { switchToLevel } from "../ai-first/helpers";
import { text } from "@quickpoint.me/shared";

const textBased: StepType[] = [
	{
		selector: "window",
		content: () => (
			<TourStepContent
				description={() => <strong>{text.tourSteps.a11yTextBasedHeading}</strong>}
			/>
		),
		position: "center",
	},
	{
		selector: "#tab-chat",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.a11yAiNativePrefix} <strong>{text.tourSteps.a11yAiNative}</strong> {text.tourSteps.a11yAiNativeSuffix}
						<br />
						<br />
						{text.tourSteps.a11yChatTab}
					</span>
				)}
			/>
		),
		action: () => {
			switchToLevel(1);
		},
	},
	{
		selector: "#tab-structure",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.a11yStructureTab}
						<br />
						<br />
						{text.tourSteps.a11yReadableText}
					</span>
				)}
			/>
		),
		action: () => {
			switchToLevel(3);
		},
	},
	{
		selector: ".qp-editor",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.a11yEditorFull}
						<br />
						<br />
						- {text.tourSteps.a11yAriaLive}
						<br />
						- {text.tourSteps.a11yLineByLine}
						<br />
						- {text.tourSteps.a11yAutocomplete}
					</span>
				)}
			/>
		),
		position: "right",
	},
];

export default textBased;
